import {
	BADGE_HEIGHT,
	CLOSE_ICON_SIZE,
	ICON_SIZE,
} from '@dealstack/frontend/app/pages/Valuations/components/OverflowBadgeList/OverflowBadgeList.utils';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { Badge, rem, Text } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { forwardRef } from 'react';
import { BadgeListItem } from './OverflowBadgeList.utils.types';

interface Props {
	badge: BadgeListItem;
	onRemove?: (id: string) => void;
	ref?: React.Ref<HTMLDivElement>;
	style?: React.CSSProperties;
}

export const OverflowBadge = forwardRef<HTMLDivElement, Props>(
	({ badge, onRemove, style }, ref) => {
		return (
			<Badge
				data-testid={badge.testId ?? TEST_ELEMENT_IDS.OVERFLOW_BADGE}
				size="sm"
				variant={badge.selected ? 'light' : 'outline'}
				color={badge.selected ? 'blue.4' : 'gray.4'}
				leftSection={
					badge.iconVariant && (
						<Icon
							color={defaultTheme.v3.colors.dark[4]}
							variant={badge.iconVariant}
							style={{
								width: rem(ICON_SIZE),
								height: rem(ICON_SIZE),
							}}
						/>
					)
				}
				rightSection={
					onRemove && (
						<IconX
							data-testid={TEST_ELEMENT_IDS.OVERFLOW_REMOVE}
							size={CLOSE_ICON_SIZE}
							color={defaultTheme.v3.colors.dark[4]}
							style={{ paddingTop: rem(1), cursor: 'pointer' }}
							onClick={() => {
								onRemove(badge.id);
							}}
							onMouseDown={(e) => e.stopPropagation()}
						/>
					)
				}
				onClick={badge.onBadgeClick}
				styles={{
					root: {
						fontVariantNumeric: 'normal',
						maxHeight: rem(BADGE_HEIGHT),
						padding: '0.25rem 0.5rem',
						cursor: badge.onBadgeClick ? 'pointer' : 'auto',
					},
					inner: {
						fontVariantNumeric: 'normal',
					},
				}}
				style={{ ...style, padding: '0.25rem 0.5rem' }}
			>
				<Text
					ref={ref}
					c="dark.4"
					fw={400}
					size="0.75rem"
					lh="1rem"
					style={{
						textAlign: 'center',
						whiteSpace: 'nowrap',
						letterSpacing: '0',
						fontFeatureSettings: 'normal',
						fontVariantNumeric: 'normal',
					}}
				>
					{badge.label}
				</Text>
			</Badge>
		);
	}
);

OverflowBadge.displayName = 'OverflowBadge';
